import type { ReactNode } from "react";

interface StaffAuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

/** The centred card the staff sign-in, forgot-password and set-password pages share. */
export function StaffAuthCard({ title, subtitle, children }: StaffAuthCardProps): React.ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-[400px] rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
        <p className="mb-1 text-center text-xs font-semibold uppercase tracking-wide text-gray-500">
          VendorPay Staff
        </p>
        <h1 className={`text-center text-2xl font-bold text-gray-900 ${subtitle ? "mb-2" : "mb-6"}`}>{title}</h1>
        {subtitle && <p className="mb-6 text-center text-sm text-gray-500">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}

export const inputClass =
  "w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500";

export const primaryButtonClass =
  "w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

export const linkClass = "text-blue-600 hover:text-blue-800";
